module.exports = __webpack_public_path__ + "static/img/no-network.c578e995.svg";